import { makeStyles } from '@map/theme';
import { Badge } from '@mui/material';
import { useChatUnreadMessages } from '@shared/lib/zendesk/hooks';
import { ReactNode } from 'react';

const useStyles = makeStyles(({ borderRadius, spacing }) => ({
  root: {
    minWidth: spacing(2.5),
    height: spacing(2.5),
    borderRadius: borderRadius('circle'),
  },
}));

const UnreadChatBadge = ({
  children,
  invisible = true,
}: {
  children: ReactNode;
  invisible?: boolean;
}) => {
  const { classes } = useStyles();
  const unreadMessageCount = useChatUnreadMessages();

  return (
    <Badge
      color="error"
      variant="dot"
      overlap="circular"
      invisible={unreadMessageCount === 0 && invisible}
      anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
      classes={{ badge: classes.root }}
    >
      {children}
    </Badge>
  );
};

export default UnreadChatBadge;
